import React from 'react';

export const MoneyExchangeSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
    >
      <rect
        width={40}
        height={40}
        fill='#FFF7F2'
        rx={20}
      />
      <path
        fill='#040325'
        fillRule='evenodd'
        d='M28.661 21.39c-.667 4.18-4.293 7.38-8.661 7.38-4.084 0-7.52-2.796-8.494-6.577a.563.563 0 0 0-1.09.28c1.1 4.267 4.976 7.423 9.584 7.423 5.049 0 9.22-3.79 9.821-8.677l.296.275a.563.563 0 0 0 .765-.825l-1.166-1.082a.563.563 0 0 0-.765 0l-1.167 1.082a.563.563 0 0 0 .765.825l.112-.104Zm-9.224-5.328a2.25 2.25 0 0 0-2.25 2.25 2.25 2.25 0 0 0 2.25 2.25v2.25H18.2a.563.563 0 0 0 0 1.125h1.238v.563a.563.563 0 0 0 1.125 0v-.563a2.25 2.25 0 0 0 2.25-2.25 2.25 2.25 0 0 0-2.25-2.25v-2.25H21.8a.563.563 0 0 0 0-1.125h-1.238V15.5a.563.563 0 0 0-1.125 0v.562Zm1.125 4.5v2.25a1.127 1.127 0 0 0 1.125-1.124v-.001a1.126 1.126 0 0 0-1.125-1.125ZM10.18 18.781l-.296-.275a.563.563 0 0 0-.765.825l1.166 1.081c.216.2.55.2.765 0l1.167-1.08a.563.563 0 0 0-.765-.826l-.112.104c.667-4.181 4.293-7.381 8.661-7.381 4.084 0 7.52 2.797 8.494 6.578a.563.563 0 0 0 1.09-.281c-1.1-4.266-4.976-7.422-9.584-7.422-5.049 0-9.22 3.789-9.821 8.677Zm9.258-1.594a1.127 1.127 0 0 0-1.125 1.125 1.126 1.126 0 0 0 1.125 1.125v-2.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
